import { render, staticRenderFns } from "./PageFixed.vue?vue&type=template&id=35310203"
import script from "./PageFixed.vue?vue&type=script&lang=js"
export * from "./PageFixed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports